import { Box, Theme, Typography } from '@mui/material';
import { VerdictDot } from '@/components/letter/VerdictDot';
import React, { FC, ReactElement } from 'react';

interface Props {
  /** Whether the group holds the declined photos, which is what its leading dot says. */
  declined: boolean;
  /** The verdict the group carries. */
  title: string;
  /** How many photos are in the group, spelled the way its own screen spells it. */
  count: string;
}

/**
 * The header of one verdict group of photos: a coloured dot, the verdict and the count behind it.
 */
export const PhotoGroupHeading: FC<Props> = (props: Props): ReactElement => {
  const { declined, title, count } = props;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <VerdictDot declined={declined} />
      <Typography variant={'body2'} component={'p'} fontWeight={600}>
        {title}
      </Typography>
      <Typography variant={'body2'} component={'p'} sx={{ color: (theme: Theme): string => theme.colors.grayText }}>
        {`· ${count}`}
      </Typography>
    </Box>
  );
};
